export const utilsTime = {
  formatTime: (inputDateString) => {
    const options = { hour: 'numeric', minute: 'numeric', hour12: true };

    const formattedTime = new Date(inputDateString).toLocaleTimeString('en-US', options);

    return formattedTime;
  },
};
